import type { ReactElement, ReactNode } from 'react'

import { condominiumCreditFaq } from 'data/condominium-credit'
import type { AccordionProps } from 'modules/help-v2/help.model'

type AnswerPart = string | ReactElement

/**
 * Quebra a resposta nos trechos marcados como destaque e devolve o texto com
 * eles em negrito. Um destaque que não é encontrado simplesmente não aparece
 * em negrito — o teste deste diretório cobre essa divergência, para que uma
 * edição de cópia falhe no CI em vez de perder o destaque em silêncio.
 */
const withHighlights = (answer: string, highlights?: string[]): ReactNode => {
  if (!highlights?.length) return answer

  const parts = highlights.reduce<AnswerPart[]>(
    (acc, highlight) =>
      acc.flatMap<AnswerPart>(part => {
        if (typeof part !== 'string' || !part.includes(highlight)) return [part]

        const [head, ...rest] = part.split(highlight)

        return [head, <b key={highlight}>{highlight}</b>, rest.join(highlight)]
      }),
    [answer]
  )

  return parts.filter(part => part !== '')
}

export const condominiumCreditAccordion: AccordionProps[] = condominiumCreditFaq.map(
  ({ id, question, answer, highlights }) => ({
    id,
    title: question,
    item: [
      {
        id: `${id}-answer`,
        type: 'text',
        content: withHighlights(answer, highlights)
      }
    ]
  })
)
